import complianceJson from './fixtures/w2/compliance.json'
import type { Risk, RiskType, Violation } from './types'

type RawViolation = Omit<Violation, 'state'>
type RawRisk = Omit<Risk, 'state' | 'type'> & { type: RiskType }

interface ComplianceFixture {
  violations: RawViolation[]
  risks: RawRisk[]
}

const fixture = complianceJson as unknown as ComplianceFixture

export const initialViolations: Violation[] = fixture.violations.map((violation) => ({
  ...violation,
  state: 'open',
}))

export const initialRisks: Risk[] = fixture.risks.map((risk) => ({
  ...risk,
  state: 'open',
}))

export function cloneInitialViolations(): Violation[] {
  return structuredClone(initialViolations)
}

export function cloneInitialRisks(): Risk[] {
  return structuredClone(initialRisks)
}
